module.exports = __webpack_public_path__ + "media/pages/Home/images/CareForMotherEarth-b8f080bde348843d8abcf80fb95f9ae4.jpg";